import React, { useState, useEffect, useReducer } from "react";
import AddIcon from "@material-ui/icons/Add";
import Button from "@material-ui/core/Button";
import { Checkbox } from "@material-ui/core";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { useSnackbar } from "notistack";
import Joi from "@hapi/joi";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";

import { Autocomplete } from "@material-ui/lab/";
import { notifications } from "../../../../utils/messages";
import maths from "../../../../utils/maths";
import { messages } from "../../../common/es_ES";
import { saveRequirement } from "../../../../services/requirementService";
import {
  typesCuatrimestre,
  typesRequirements,
} from "../../../../utils/constants";
import { RadioGroup } from "@material-ui/core";

const AddRequirementForm = React.memo(
  ({
    activities,
    plannedBudget,
    executedBudget,
    component,
    populateRequirements,
  }) => {
    const initialState = {
      sCuatri: [],
      data: {
        type: 1,
        name: "",
        code_cpc: "",
        quantity: "",
        price: "0.00",
        iva: "",
        cuatrimestre1: "",
        porcentajec1: "",
        cuatrimestre2: "",
        porcentajec2: "",
        cuatrimestre3: "",
        porcentajec3: "",
        total_price: "0.00",
        activity_id: "",
      },
      errors: {},
      selectedOptions: [],
    };

    const cuatrimestres = [
      { id: 1, name: typesCuatrimestre.PRIMER },
      { id: 2, name: typesCuatrimestre.SEGUNDO },
      { id: 3, name: typesCuatrimestre.TERCERO },
    ];
    const types = [
      { id: 1, name: typesRequirements.BIEN },
      { id: 2, name: typesRequirements.OBRA },
      { id: 3, name: typesRequirements.SERVICIO },
      { id: 4, name: typesRequirements.CONSULTORIA },
    ];

    const kinds = [
      { id: 12, name: "IVA 12%" },
      { id: 0, name: "IVA 0%" },
    ];

    const [state, setState] = useState(initialState);
    const { enqueueSnackbar } = useSnackbar();
    const [open, setOpen] = React.useState(false);

    const [textFieldActivo, setTextFieldActivo] = useState(false);
    const [textFieldActivo2, setTextFieldActivo2] = useState(false);
    const [textFieldActivo3, setTextFieldActivo3] = useState(false);

    function reducer(state, action) {
      switch (action.type) {
        case "SET_SELECTED_OPTIONS":
          return {
            selectedOptions: action.payload.options,
          };

        case "REMOVE_OPTION":
          return {
            selectedOptions: state.selectedOptions.filter(
              (option) => option.id !== action.payload.id
            ),
          };
        default:
          throw new Error();
      }
    }

    const [states, dispatch] = useReducer(reducer, initialState);

    const handleChangeCuatri = (event, values) => {
      dispatch({ type: "SET_SELECTED_OPTIONS", payload: { options: values } });
      const data = { ...state.data };
      data["cuatrimestre1"] = "";
      data["cuatrimestre2"] = "";
      data["cuatrimestre3"] = "";
      setTextFieldActivo(false);
      setTextFieldActivo2(false);
      setTextFieldActivo3(false);

      setState((prevState) => ({ ...prevState, data }));
      let vvv = values;
      for (let i = 0; i < vvv.length; i++) {
        let info = vvv[i];
        if (info.id === 1) {
          data["cuatrimestre1"] = info.name;
          setTextFieldActivo(true);
        } else if (info.id === 2) {
          data["cuatrimestre2"] = info.name;
          setTextFieldActivo2(true);
        } else if (info.id === 3) {
          data["cuatrimestre3"] = info.name;
          setTextFieldActivo3(true);
        }
      }
    };

    /* const removeOption = (id) => {
    dispatch({ type: "REMOVE_OPTION", payload: { id: id } });
  };*/

    const handleClickOpen = () => {
      setOpen(true);
    };

    const handleClose = () => {
      setOpen(false);
    };

    const handleChange = ({ target: input }) => {
      const errors = { ...state.errors };
      const errorMessage = validateProperty(input);
      if (errorMessage) errors[input.name] = errorMessage;
      else delete errors[input.name];

      const data = { ...state.data };
      data[input.name] = input.value;
      setState((prevState) => ({ ...prevState, data, errors }));
    };

    const handleChangeSelect = (event, newValue, nameSelect) => {
      const data = { ...state.data };
      nameSelect !== "type"
        ? (data[nameSelect] = newValue.id)
        : (data[nameSelect] = newValue.name);
      setState((prevState) => ({ ...prevState, data }));
    };

    const handleChangeSelectIva = (event, newValue, nameSelect) => {
      const data = { ...state.data };
      nameSelect !== "iva"
        ? (data[nameSelect] = newValue.id)
        : (data[nameSelect] = newValue.name);
      setState((prevState) => ({ ...prevState, data }));
      const total = data["quantity"] * data["price"];

      if (data[nameSelect] === "IVA 12%") {
        data["total_price"] = maths.round(total * 0.12 + total);
        data[nameSelect] = 12;
      } else {
        data["total_price"] = maths.round(total);
        data[nameSelect] = 0;
      }
    };

    const validateProperty = ({ name, value }) => {
      const obj = { [name]: value };
      const { error } = schema.validate(obj);
      return error ? error.details[0].message : null;
    };

    const schema = Joi.object({
      type: Joi.array().label("Tipo compra").messages(messages),
      name: Joi.string()
        .label("Descripción")
        .min(3)
        .max(5000)
        .messages(messages),
      code_cpc: Joi.string()
        .label("Código CPC")
        .min(3)
        .max(5000)
        .messages(messages),
      cuatrimestre: Joi.string()
        .label("Cuatrimestre")
        .min(3)
        .max(500)
        .messages(messages),
      quantity: Joi.number()
        .label("Cantidad")
        .positive()
        .integer()
        .messages(messages),
      price: Joi.number()
        .precision(2)
        .label("Precio unitario")
        .positive()
        .messages(messages),
      porcentajec1: Joi.number()
        .precision(2)
        .label("Cuatrimestre 1 (%)")
        .positive()
        .messages(messages),
      porcentajec2: Joi.number()
        .precision(2)
        .label("Cuatrimestre 2 (%)")
        .positive()
        .messages(messages),
      porcentajec3: Joi.number()
        .precision(2)
        .label("Cuatrimestre 3 (%)")
        .positive()
        .messages(messages),
      total_price: Joi.number()
        .precision(2)
        .label("Precio total")
        .messages(messages),
    });

    const handleSubmit = async () => {
      try {
        handleClose();

        await saveRequirement(state.data);
        await populateRequirements(component.id);
        await plannedBudget();
        await executedBudget();
        enqueueSnackbar(notifications.SUCCESS, { variant: "success" });
        //setState({ ...initialState });
      } catch (ex) {
        enqueueSnackbar(`${ex.response.data.message}`, { variant: "error" });
      }
    };

    useEffect(() => {});

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    return (
      <div>
        <Button
          className="addComponent"
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={handleClickOpen}
        >
          Agregar Requerimiento
        </Button>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            Agregar requerimiento
          </DialogTitle>

          <DialogContent>
            <Autocomplete
              id={"type"}
              name={"type"}
              limitTags={2}
              options={types}
              disableClearable
              getOptionLabel={(type) => type.name}
              onChange={(event, values) =>
                handleChangeSelect(event, values, "type")
              }
              label={"Tipo Compra *"}
              //value={this.state.data.user}
              renderOption={(option, { selected, inputValue }) => {
                //console.log("inputvalue:" + selected + "; " + inputValue);
                return (
                  <React.Fragment>
                    <RadioGroup
                      name={"type"}
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.name}
                  </React.Fragment>
                );
              }}
              getOptionSelected={(option, value) => {
                return option.id === value.id;
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  //error={validation}
                  margin="normal"
                  variant="outlined"
                  label={"Tipo compra *"}
                  size="small"
                  placeholder="Tipo de compra a la que pertenece"
                  fullWidth
                />
              )}
            />
            <TextField
              error={state.errors["name"] === undefined ? false : true}
              margin="dense"
              name="name"
              label="Descripción del requerimiento *"
              type="text"
              fullWidth
              multiline
              maxRows="2"
              variant="outlined"
              size="small"
              onChange={handleChange}
              helperText={state.errors["name"]}
            />
            <TextField
              required={false}
              error={state.errors["code_cpc"] === undefined ? false : true}
              margin="dense"
              name="code_cpc"
              label="Código CPC"
              type="text"
              fullWidth
              multiline
              maxRows="2"
              variant="outlined"
              size="small"
              onChange={handleChange}
              helperText={state.errors["code_cpc"]}
            />
            <Autocomplete
              multiple
              id={"cuatrimestre"}
              name={"cuatrimestre"}
              options={cuatrimestres}
              getOptionLabel={(cuatrimestre) => cuatrimestre.name}
              value={states.selectedOptions}
              getOptionSelected={(option, value) => {
                return option.id === value.id;
              }}
              onChange={handleChangeCuatri}
              /*onChange={(event, values) =>
                handleChangeSelectC(event, values, 'cuatrimestre')
              }*/
              label={"Cuatrimestre*"}
              //value={this.state.data.user}
              renderOption={(option, { selected, inputValue }) => {
                return (
                  <React.Fragment>
                    <Checkbox
                      name={"cuatrimestre"}
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.name}
                  </React.Fragment>
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  //error={validation}
                  margin="normal"
                  variant="outlined"
                  label={"Cuatrimestre *"}
                  size="small"
                  placeholder="Seleccione el Cuatrimestre"
                  fullWidth
                />
              )}
            />

            <TextField
              disabled={!textFieldActivo}
              error={state.errors["porcentajec1"] === undefined ? false : true}
              margin="dense"
              id="porcentajec1"
              name="porcentajec1"
              label="Cuatrimestre 1 (%)"
              type="number"
              fullWidth
              variant="outlined"
              size="small"
              onChange={handleChange}
              helperText={state.errors["porcentajec1"]}
            />

            <TextField
              disabled={!textFieldActivo2}
              error={state.errors["porcentajec2"] === undefined ? false : true}
              margin="dense"
              name="porcentajec2"
              label="Cuatrimestre 2 (%)"
              type="number"
              fullWidth
              variant="outlined"
              size="small"
              onChange={handleChange}
              helperText={state.errors["porcentajec2"]}
            />

            <TextField
              disabled={!textFieldActivo3}
              error={state.errors["porcentajec3"] === undefined ? false : true}
              margin="dense"
              name="porcentajec3"
              label="Cuatrimestre 3 (%)"
              type="number"
              fullWidth
              variant="outlined"
              size="small"
              onChange={handleChange}
              helperText={state.errors["porcentajec3"]}
            />

            <TextField
              error={state.errors["quantity"] === undefined ? false : true}
              margin="dense"
              name="quantity"
              label="Cantidad *"
              type="number"
              fullWidth
              variant="outlined"
              size="small"
              onChange={handleChange}
              helperText={state.errors["quantity"]}
            />
            <TextField
              error={state.errors["price"] === undefined ? false : true}
              margin="dense"
              name="price"
              label="Precio unitario USD *"
              type="number"
              fullWidth
              variant="outlined"
              size="small"
              onChange={handleChange}
              helperText={state.errors["price"]}
            />
            <Autocomplete
              id={"iva"}
              name={"iva"}
              limitTags={1}
              options={kinds}
              disableClearable
              getOptionLabel={(iva) => iva.name}
              onChange={(event, values) =>
                handleChangeSelectIva(event, values, "iva")
              }
              label={"IVA *"}
              renderOption={(option, { selected, inputValue }) => {
                //console.log("inputvalue:" + selected + "; " + inputValue);
                return (
                  <React.Fragment>
                    <RadioGroup
                      name={"iva"}
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.name}
                  </React.Fragment>
                );
              }}
              getOptionSelected={(option, value) => {
                return option.id === value.id;
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  //error={validation}
                  margin="normal"
                  variant="outlined"
                  label={"IVA *"}
                  size="small"
                  placeholder="Tipo de IVA "
                  fullWidth
                />
              )}
            />

            <TextField
              error={state.errors["total_price"] === undefined ? false : true}
              margin="dense"
              name="total_price"
              label="Precio total USD *"
              type="text"
              fullWidth
              variant="outlined"
              size="small"
              value={state.data.total_price}
              disabled
              onChange={handleChange}
              helperText={state.errors["total_price"]}
            />
            <Autocomplete
              //multiple
              id={"activity"}
              name={"activity"}
              limitTags={2}
              options={activities}
              //disableCloseOnSelect
              disableClearable
              getOptionLabel={(activity) => activity.name}
              onChange={(event, values) =>
                handleChangeSelect(event, values, "activity_id")
              }
              label={"Actividad *"}
              //value={this.state.data.user}
              renderOption={(option, { selected, inputValue }) => {
                //console.log("inputvalue:" + selected + "; " + inputValue);
                return (
                  <React.Fragment>
                    <Checkbox
                      name={"activity"}
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.name}
                  </React.Fragment>
                );
              }}
              getOptionSelected={(option, value) => {
                return option.id === value.id;
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  //error={validation}
                  margin="normal"
                  variant="outlined"
                  label={"Actividad *"}
                  size="small"
                  placeholder="Actividad a la que pertenece"
                  fullWidth
                  //helperText={error}
                />
              )}
            />
            <Button
              onClick={handleSubmit}
              color="primary"
              className="btn btn-guardar"
              variant="contained"
              margin="normal"
              size="medium"
            >
              Guardar
            </Button>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
);

export default AddRequirementForm;
